module.exports = __webpack_public_path__ + "static/media/doordash.c8c4ca3b.png";